import { getCoreAjax } from '../../utils/moodle-amd';
import get_board from './get-board';

export default async () => {
  const modBoard = document.querySelector('.mod_board');
  if (!modBoard) return;

  const boardData = await get_board();

  if (!boardData || !boardData.length) {
    console.warn('No board data found, skipping markup injection');
    return;
  }

  // If already present, set up immediately
  if (markupInjector()) return;

  // Otherwise observe until they appear, then set up and stop
  const observer = new MutationObserver((_, obs) => {
    if (markupInjector()) obs.disconnect();
  });

  observer.observe(modBoard, {
    childList: true,
    subtree: true
  });

  function markupInjector() {
    const isPostOwnerProfileInjected = injectPostOwnerProfile();

    return isPostOwnerProfileInjected;
  }

  function injectPostOwnerProfile() {
    const boardNotes = modBoard.querySelectorAll('.board_note');
    if (!boardNotes.length) return false;

    boardNotes.forEach((note) => {
      const boardNoteContent = note.querySelector('.mod_board_note_content');

      // find matching data for this note from sort order
      const sortOrder = Number(note.dataset.sortorder);
      const boardNoteData = boardData[0]?.notes?.find(
        (e) => e.sortorder === sortOrder
      );

      if (!boardNoteData) {
        console.warn(
          'No matching board note data found for sort order',
          sortOrder
        );
        return;
      }

      // Inject profile markup
      const profileMarkup = getPostOwnerProfileMarkup(boardNoteData);
      boardNoteContent.insertAdjacentElement('afterbegin', profileMarkup);
    });

    return true;
  }

  function getPostOwnerProfileMarkup(boardNoteData) {
    const userid = boardNoteData.userid;
    const fullname = boardNoteData.fullname;
    const profileimageurl = boardNoteData.profileimageurl;

    const profileMarkup = document.createElement('div');
    profileMarkup.className = 'mod_board_note_profile';

    profileMarkup.innerHTML = '';
    profileimageurl && (profileMarkup.innerHTML += `<img src="${profileimageurl}" alt="">`);
    fullname && (profileMarkup.innerHTML += `<p>${fullname}</p>`);

    return profileMarkup;
  }
};
